// extracted by mini-css-extract-plugin
export default {"dataCell":"TableHead_dataCell__xck1D","sortIcon":"TableHead_sortIcon__m9AMn","MuiTableSortLabel-icon":"TableHead_MuiTableSortLabel-icon__x+Kic"};